"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const DeleteConfirmationModal = ({ onCancel }) => {
    const onClose = () => {
        components_1.modalEvents.remove();
    };
    const onCancelConfirm = () => {
        onCancel();
        onClose();
    };
    return (react_1.default.createElement(components_1.ModalTemplate, { title: constants_1.default.subscriptions.areYouSureCancel, onClose: onClose, ariaLabel: "Delete account", width: 630 },
        react_1.default.createElement("p", null, constants_1.default.subscriptions.youWillRetain),
        react_1.default.createElement(components_1.ModalTemplate.Footer, null,
            react_1.default.createElement(components_1.Button, { title: constants_1.default.general.cancel, variant: "secondary", onClick: onClose, ariaLabel: "cancel" }),
            react_1.default.createElement(components_1.Button, { title: constants_1.default.subscriptions.cancelSubscription, variant: "error", onClick: onCancelConfirm, ariaLabel: "delete" }))));
};
exports.default = DeleteConfirmationModal;
